import { Text } from '@vkontakte/vkui';
import classNames from 'clsx';
import React, { type FC, memo, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { cloudFilesMigrationDesktopSidebarLink } from 'reactApp/appHelpers/featuresHelpers/features/cloudFilesMigrationDesktop';
import { cdnPackagesUrl } from 'reactApp/appHelpers/themeToolHelpers/default-values';
import { isCurrentDarkTheme } from 'reactApp/modules/theme/theme.selectors';
import { sendDwh } from 'reactApp/utils/ga';
import opener from 'reactApp/utils/opener';
import { ECategoryGa } from 'reactApp/utils/paymentGa';

import styles from './TelegramMigrationSidebarBanner.css';

const onClick = () => {
    sendDwh({
        eventCategory: ECategoryGa.telegram,
        action: 'click',
        dwhData: {
            enter_point: 'sider',
        },
    });
    opener(cloudFilesMigrationDesktopSidebarLink);
};

export const TelegramMigrationSidebarBanner: FC = memo(function TelegramMigrationSidebarBanner() {
    const isDarkTheme = useSelector(isCurrentDarkTheme);

    useEffect(() => {
        sendDwh({
            eventCategory: ECategoryGa.telegram,
            action: 'show',
            dwhData: {
                enter_point: 'sider',
            },
        });
    }, []);

    return (
        <div className={classNames(styles.root, { [styles.darkRoot]: isDarkTheme })} onClick={onClick} data-test-id="tgmig-sidebar-banner">
            <Text className={styles.text}>
                Скопируйте файлы
                <br />
                из Telegram в&nbsp;Облако
            </Text>
            <img
                className={styles.image}
                src={`${cdnPackagesUrl}/static/cloud/tgmig/promo/sidebar-banner-${isDarkTheme ? 'dark' : 'light'}.webp`}
                alt="Миграция файлов из Telegram"
            />
        </div>
    );
});
